export function sameStringArray(a?: string[], b?: string[]): boolean {
  return (
    (a?.length ?? 0) === (b?.length ?? 0) &&
    (a ?? []).every((value, index) => value === (b ?? [])[index])
  )
}
